import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {AuditType, getProcessTypeForStandard, Order, OrderStatusEnum, ProcessType, Product} from "../../../store/state/order.state";
import {ChangeSet} from "../history/order-history.model";

@Component({
    selector: 'additional-questions-details',
    templateUrl: './additional-questions-details.template.html',
    styleUrls: ['./additional-questions-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AdditionalQuestionsDetailsComponent implements OnInit {

	@Input() order: Order;
	@Input() changeSet: ChangeSet;	// optional
	@Input() translateClientsData;
	@Input() useOriginalTranslations: boolean;
	@Input() detailsVisible: boolean = false;
	@Input() editable: boolean = true;
	@Input() collapsable: boolean = true;
	@Input() clientContext: boolean = false;
	@Output() changeRequested: EventEmitter<any> = new EventEmitter<any>();

	ngOnInit(): void {
		this.detailsVisible = this.detailsVisible ? this.detailsVisible :
			(this.clientContext ? this.detailsVisible : this.isTranslation());
	}

	isTransfer(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) == ProcessType.TRANSFER;
	}

	isFirstYearInitial(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) == ProcessType.INITIAL_CERTIFICATION && (product.currentAuditEvent == null || product.currentAuditEvent == AuditType.INITIAL_CERTIFICATION);
	}

	isRecertification(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) == ProcessType.RECERTIFICATION;
	}

	isTranslation(): boolean {
		return this.order.status == OrderStatusEnum.TRANSLATION;
	}
}
